import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SelectableNavigationItem} from '../../../model/selectable-navigation-item';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {PageNames} from '../../../shared/page-names.enum';
import {EmitterConstants} from '../../../shared/emitter-constants';
import {Emitter} from '../../../shared/utils/emitter/emitter';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {KeyDirections} from '../../../shared/key-directions.enum';

@Component({
  selector: 'app-input-trial-code',
  templateUrl: './input-trial-code.component.html',
  styleUrls: ['./input-trial-code.component.less']
})
export class InputTrialCodeComponent extends SelectableNavigationItem implements OnInit {
  @Input() x: number;
  @Input() y: number;
  @Input() invalidTrialCode: boolean;
  @Output() emitOnEnterPressed = new EventEmitter<Object>();
  @ViewChild('inputCode', {read: ElementRef})
  inputCode: ElementRef;
  inputForm: FormGroup;

  constructor(private navigationService: NavigationService) {
    super();
    this.navigationService.registerNavigation(this, PageNames.TRIAL_CODE_MODAL);
  }

  ngOnInit(): void {
    this.inputForm = new FormGroup({
      code: new FormControl([''], Validators.required)
    }, {}, null);
    this.detectInputValueChanges();
  }

  detectInputValueChanges(): void {
    this.inputForm.valueChanges.subscribe(value => {
      this.inputForm.setValue(
        {code: this.handleInputWhitespace(value.code)}, {emitEvent: false}
      );

      Emitter.of(EmitterConstants.INPUT_TRIAL_CODE).emit(
        {code: this.inputForm.value.code.toString().replace(/\D/g, '')}
      );
    });
  }

  onBack(): void {
    (document.activeElement as HTMLElement).blur();
    Emitter.of(EmitterConstants.BACK_PRESSED).emit(PageNames.TRIAL_CODE_MODAL);
  }

  onEnter(): void {
    this.emitOnEnterPressed.emit({
      value: true
    });
  }

  activate(active: boolean): void {
    this.active = active;
    if (this.active) {
      setTimeout(() => {
        this.inputCode.nativeElement.focus();
      }, 100);
    }
  }

  handleInputWhitespace(code: string): string {
    return code.toString()
      .replace(/\D/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim();
  }

  containsValue(): boolean {
    return this.inputForm.value.code.toString() !== '';
  }

  handleEvent($event): void {
    if ($event.keyCode === KeyDirections.ARROW_LEFT && this.inputForm.value.code) {
      this.removeTheLastCharacter();
    }
  }

  private removeTheLastCharacter(): void {
    this.inputForm.setValue({code: this.inputForm.value.code.toString().slice(0, -1)}, { emitEvent: true });
  }
}
